var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 17.5C17.499 17.5 20.4995 13.5 20.4995 10.5H3.49951C3.49951 13.5 6.50004 17.5 11.9995 17.5Z",
    stroke: "#022B54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10V7.5H8.5V9",
    stroke: "#022B54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20703 16.293L5.79282 17.7072",
    stroke: "#022B54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.793 16.293L18.2072 17.7072",
    stroke: "#022B54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.550dc34bde43384ec61bcca63badbbd0.svg";
export { ForwardRef as ReactComponent };